module.exports = "/images/daffah.png?06cc6eb9c2473b7014abd9d78a8662c7";